<template>
  <ui-card name="trip.overview" :error="error" rounded>
    <trip-chart :start="start" :end="end" :waypoints="waypoints" :annotations="annotations" />
  </ui-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import TripChart from 'charts/TripChart';

export default {
  name: 'TripOverview',

  components: {
    TripChart,
  },

  computed: {
    ...mapState('trip', ['start', 'end', 'trajectory']),

    ...mapState('trip', {
      annotations: 'behavior_annotations',
    }),

    ...mapGetters('trip', ['waypoints']),

    error() {
      const hasData =
        this.start && this.end && this.waypoints && this.annotations;

      if (
        !hasData ||
        this.waypoints.length === 0 ||
        this.annotations.length === 0
      ) {
        return 'missing_data';
      }

      return null;
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  height: 100%;
}
</style>
